import * as React from "react";

import { PropertySearchLink as SharedUiPropertySearchLink } from "@shared-ui/lodging-property-offers";

import { ShortListWrapper } from "./ShortListWrapper";

import { PropertyBexApiWrapper } from "components/shared/BexApiWrapper/PropertyBexApiWrapper";
import { ComponentProps } from "typings/flexFramework/FlexComponent";

import { UitkSpacing } from "uitk-react-spacing";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";

const WrappedSearchLink = PropertyBexApiWrapper(SharedUiPropertySearchLink);

export const PropertySearchLink: React.FC<ComponentProps> = ({ context }) => {
  return (
    <UitkSpacing padding={{ block: "two" }}>
      <UitkLayoutFlex justifyContent="space-between" alignItems="center">
        <UitkLayoutFlexItem>
          <div>
            <WrappedSearchLink context={context} />
          </div>
        </UitkLayoutFlexItem>
        <UitkLayoutFlexItem>
          <div>
            <ShortListWrapper context={context} />
          </div>
        </UitkLayoutFlexItem>
      </UitkLayoutFlex>
    </UitkSpacing>
  );
};

export default PropertySearchLink;
